<app-search-bar
    *ngIf="isResourceMenuReady() && premiumCollectionOfResource"
    [collectionSlug]="premiumCollectionOfResource.slug"
    [collectionTitle]="premiumCollectionOfResource.title"
    [colors]="premiumCollectionOfResource.styleContent"
    [logo]="premiumCollectionOfResource.logo"
    class="gtm-resource-page"
></app-search-bar>
<div>
    <div
        *ngIf="!resourceService.focusView"
        class="container gtm-resource-page"
        [ngClass]="{ 'mt-1': isAddonView }"
        [@routeTransition]="activatedRoute.snapshot.params"
    >
        <div
            class="back-to-search mt-4 ms-6"
            *ngIf="isPreviousPage && !userService.hasStudentExperience()"
        >
            <a
                class="selenium-back-to-search"
                href="#"
                (click)="navigateToPreviousUrl(); $event.preventDefault()"
                routerLinkActive="active"
            >
                &#60; Back to search results
            </a>
        </div>
        <app-element-placeholder
            *ngIf="!resource.isLoaded"
            class="loading-placeholder"
        ></app-element-placeholder>
        <div class="row-auto gtm-prefix-resource">
            <div
                [ngClass]="{
                    'd-none': !isResourceMenuReady(),
                    'resource-menu col-xs-12 col-sm-12 col-md-12 col-lg-1 px-4':
                        isResourceMenuReady(),
                    'align-next-to-asset-view': alignToTopOfAssetView(),
                }"
            >
                <div class="row-auto g-0 icons-group mt-3">
                    <ng-container *ngIf="!hasStudentExperience() && !isAddonView">
                        <app-link-button
                            (trigger)="assignToGoogleClassroomClass()"
                            [disable]="
                                !resource.isAvailableToStudents || (isInPreviewMode$ | async)
                            "
                            [tooltip]="(isInPreviewMode$ | async) ? '' : shareToGCTooltip"
                            [tooltipPlacement]="shareButtonsPlacement"
                            [ngClass]="{
                                'disabled-share-button':
                                    !resource.isAvailableToStudents || (isInPreviewMode$ | async),
                                'preview-color': isInPreviewMode$ | async,
                            }"
                            class="gtm-share-google-classroom selenium-share-google-classroom share-resource-item mb-4"
                            hideLabelOnMobile="true"
                            hideLabelOnSmallDevices="true"
                            hideLabelOnTablet="true"
                            label="Share to Google Classroom"
                        >
                            <img [src]="googleClassroomImage" alt="Google Classroom" class="mb-1" />
                        </app-link-button>
                        <app-link-button
                            (trigger)="OpenShareLink()"
                            [disable]="
                                !resource.isAvailableToStudents || (isInPreviewMode$ | async)
                            "
                            [tooltip]="(isInPreviewMode$ | async) ? '' : shareWithStudentsTooltip"
                            [tooltipPlacement]="shareButtonsPlacement"
                            [ngClass]="{
                                'disabled-share-button':
                                    !resource.isAvailableToStudents || (isInPreviewMode$ | async),
                                'preview-color': (isInPreviewMode$ | async),
                            }"
                            class="gtm-share-link selenium-share-link-with-students share-resource-item mb-4"
                            hideLabelOnMobile="true"
                            hideLabelOnSmallDevices="true"
                            hideLabelOnTablet="true"
                            icon="AssignClass"
                            label="Share link with students"
                        >
                        </app-link-button>
                        <app-link-button
                            (trigger)="buildALesson()"
                            [disable]="!canAssign() || (isInPreviewMode$ | async)"
                            [label]="isLTI() ? 'Assign a lesson' : 'Build a lesson'"
                            [tooltip]="(isInPreviewMode$ | async) ? '' : buildLessonTooltip"
                            [ngClass]="{
                                'gtm-assign-lesson': isLTI(),
                                'gtm-build-lesson': !isLTI(),
                                'preview-color': (isInPreviewMode$ | async),
                            }"
                            class="selenium-lesson-builder share-resource-item mb-4"
                            hideLabelOnMobile="true"
                            hideLabelOnSmallDevices="true"
                            hideLabelOnTablet="true"
                            icon="lesson-builder"
                        ></app-link-button>
                        <app-link-button
                            (trigger)="onOpenShareAssignModal()"
                            [disable]="isInPreviewMode$ | async"
                            [ngClass]="{ 'preview-color': (isInPreviewMode$ | async) }"
                            class="gtm-share-assign selenium-share-assign share-resource-item mb-4"
                            hideLabelOnMobile="true"
                            hideLabelOnSmallDevices="true"
                            hideLabelOnTablet="true"
                            icon="SocialMedia"
                            label="Social share"
                            [tooltip]="
                                (isInPreviewMode$ | async)
                                    ? ''
                                    : 'Share and assign to Remind, email, Facebook, and more.'
                            "
                        >
                        </app-link-button>
                    </ng-container>
                    <app-favorite-button
                        *ngIf="!userService.hasStudentExperience() && !isAddonView"
                        [disable]="!isFavoriteDataReady() || (isInPreviewMode$ | async)"
                        [learningObjectId]="resource.favoriteId"
                        [ngClass]="{ 'preview-color': (isInPreviewMode$ | async) }"
                        class="share-resource-item mb-4"
                        hideLabelOnMobile="true"
                        hideLabelOnSmallDevices="true"
                        hideLabelOnTablet="true"
                        loggedinTooltip="Save this resource for later."
                        loggedoutTooltip="Sign in or create an account to add this resource to your Favorites. "
                    >
                    </app-favorite-button>
                    <app-link-button
                        *ngIf="isAddonView && !userService.hasStudentExperience()"
                        (trigger)="assignToGoogleClassroomClass()"
                        [disable]="!resource.isAvailableToStudents || (isInPreviewMode$ | async)"
                        [tooltip]="(isInPreviewMode$ | async) ? '' : assignToGCTooltip"
                        [ngClass]="{ 'preview-color': (isInPreviewMode$ | async) }"
                        class="gtm-share-google-classroom selenium-share-google-classroom share-resource-item mb-4"
                        hideLabelOnMobile="true"
                        hideLabelOnSmallDevices="true"
                        hideLabelOnTablet="true"
                        label="Assign to class"
                    >
                        <img [src]="googleClassroomImage" alt="Google Classroom" class="mb-1" />
                    </app-link-button>
                </div>
            </div>
            <div
                [ngClass]="{
                    'col-xs-12 coll-sm-12 col-md-12 col-lg-12': !isResourceMenuReady(),
                    'col-xs-12 coll-sm-12 col-md-12 col-lg-11 px-md-4': isResourceMenuReady(),
                }"
            >
                <app-video-resource
                    [resource]="resource"
                    *ngIf="resource.opensAsVideo"
                ></app-video-resource>
                <app-image-resource
                    [resource]="resource"
                    *ngIf="resource.opensAsImage"
                ></app-image-resource>
                <app-audio-resource
                    [resource]="resource"
                    *ngIf="resource.opensAsAudio"
                ></app-audio-resource>
                <app-document-resource
                    [resource]="resource"
                    *ngIf="resource.opensAsDocument"
                ></app-document-resource>
                <app-lesson-plan-resource
                    [resource]="resource"
                    *ngIf="resource.isLessonPlan"
                ></app-lesson-plan-resource>
                <app-media-gallery-resource
                    [resource]="resource"
                    *ngIf="resource.opensAsMediaGallery"
                ></app-media-gallery-resource>
                <app-interactive-resource
                    [resource]="resource"
                    *ngIf="resource.opensAsInteractive"
                ></app-interactive-resource>
            </div>
        </div>
    </div>
    <div
        *ngIf="resourceService.focusView"
        [@routeTransition]="activatedRoute.snapshot.params"
        class="container gtm-resource-page"
    >
        <div
            class="back-to-search mt-4 ms-6"
            *ngIf="isPreviousPage && !userService.hasStudentExperience()"
        >
            <a
                class="selenium-back-to-search"
                href="#"
                (click)="navigateToPreviousUrl(); $event.preventDefault()"
                routerLinkActive="active"
            >
                &#60; Back to search results
            </a>
        </div>
        <app-element-placeholder
            *ngIf="!resource.isLoaded"
            class="loading-placeholder"
        ></app-element-placeholder>

        <div class="row-auto gtm-prefix-resource">
            <div
                [ngClass]="{
                    'd-none': !isResourceMenuReady(),
                    'resource-menu col-xs-12 col-sm-12 col-md-12 col-lg-1': isResourceMenuReady(),
                    'align-next-to-asset-view': alignToTopOfAssetView(),
                }"
            ></div>
            <div [ngClass]="{ 'col-xs-12 coll-sm-12 col-md-12 col-lg-12': true }">
                <app-video-resource
                    [resource]="resource"
                    *ngIf="resource.opensAsVideo"
                ></app-video-resource>
                <div class="related col-xs-12 coll-sm-12 col-md-12 col-lg-11 ps-0">
                    <a
                        (click)="resourceService.switchResourceView(true); $event.preventDefault()"
                        class="link-primary"
                        href="#"
                        style="font-weight: 600"
                        >« Discover {{ !isAddonView ? "related resources and" : "" }} support
                        materials.</a
                    >
                </div>
                <div class="simple-footer-details">
                    <app-link
                        *ngIf="resource.brand && resource.brand.getLogo() && !isAddonView"
                        [appRouterLink]="'/search'"
                        [attr.data-gtmlabel]="resource.brand.name"
                        [queryParams]="{
                            q: '',
                            selected_facet: 'brand_id:' + resource.brand.id,
                        }"
                        class="brand-logo gtm-brand-logo selenium-brand-logo"
                    >
                        <img
                            alt="{{ resource.brand.name }}"
                            class="preview-brand-logo"
                            src="{{ resource.brand.getLogo() }}"
                        />
                    </app-link>
                    <img
                        *ngIf="isAddonView && userService.hasStudentExperience()"
                        alt="{{ resource.brand.name }}"
                        class="preview-brand-logo"
                        src="{{ resource.brand.getLogo() }}"
                    />
                    <app-link
                        *ngIf="resource?.creditsLink"
                        [href]="resource?.creditsLink"
                        target="_blank"
                        class="ms-6 gtm-resource-credits-link selenium-resource-credits-link"
                        >Credits
                    </app-link>
                </div>
            </div>
        </div>
    </div>
    <app-resource-attributes *ngIf="!resourceService.focusView"></app-resource-attributes>
    <app-available-features *ngIf="!resourceService.focusView"></app-available-features>
</div>
